import React from "react";
import { useTranslation } from "react-i18next";
import img1 from "../../assets/new images/heart.png";
import img2 from "../../assets/new images/AiCareer.png";

export default function HumanExpertise() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 bg-gradient-to-b from-[#f8fafc] to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Outer soft card */}
        <div className="rounded-2xl border border-orange-100 bg-gradient-to-b from-[#EE5F2B]/5 to-[#293C560D]/5    shadow-[0_8px_30px_rgba(31,41,55,0.06)] px-6 sm:px-10 py-10 md:py-12">
          <div className="grid md:grid-cols-12 gap-10 items-center">
            {/* LEFT COLUMN */}
            <div className="md:col-span-7">
              <h2 className="text-slate-800 font-bold text-3xl sm:text-4xl md:text-5xl leading-tight mb-4">
                {t("humanExpertise.heading1")}
                <br className="hidden sm:block" />
                {t("humanExpertise.heading2")}
                <br className="hidden sm:block" />
                {t("humanExpertise.heading3")}
              </h2>

              <p className="text-slate-600 text-base sm:text-lg leading-relaxed max-w-md">
                {t("humanExpertise.description")}
              </p>
            </div>

            {/* RIGHT COLUMN */}
            <div className="md:col-span-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-5">
                {/* CARD 1 */}
                <div className="flex flex-col sm:flex-row md:flex-col items-start gap-3 sm:gap-4 p-5 bg-white border border-slate-200 rounded-xl shadow-sm hover:border-orange-500 hover:shadow-xl hover:shadow-orange-500/20 transition hover:scale-105 group">
                  {/* Icon */}
          
                    <img src={img1} alt={t("humanExpertise.card1Title")} className="h-12 w-12 object-contain transition group-hover:shadow-xl group-hover:shadow-orange-500/30 rounded-2xl" />

                  {/* Text */}
                  <div>
                    <h3 className="text-md font-semibold text-slate-900">
                      {t("humanExpertise.card1Title")}
                    </h3>
                    <p className="mt-1 text-sm leading-snug text-slate-500">
                      {t("humanExpertise.card1DescLine1")} <br /> {t("humanExpertise.card1DescLine2")}
                    </p>
                  </div>
                </div>

                {/* CARD 2 */}
                <div className="flex flex-col sm:flex-row md:flex-col items-start gap-3 sm:gap-4 p-5 bg-white border border-slate-200 rounded-xl shadow-sm hover:border-orange-500 hover:shadow-xl hover:shadow-orange-500/20 transition hover:scale-105 group ">
                  {/* Icon */}
          
                    <img src={img2} alt={t("humanExpertise.card2Title")} className="h-12 w-12 object-contain transition group-hover:shadow-xl group-hover:shadow-orange-500/30 rounded-2xl" />

                  {/* Text */}
                  <div>
                    <h3 className="text-md font-semibold text-slate-900">{t("humanExpertise.card2Title")}</h3>
                    <p className="mt-1 text-sm leading-snug text-slate-500">
                      {t("humanExpertise.card2DescLine1")} <br /> {t("humanExpertise.card2DescLine2")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
